export default {
    basUrl: {
      dev: process.env.VUE_APP_API_URL_DEV,
      pro: process.env.VUE_APP_API_URL_PRO,
    },
  EQMac: {
    version:'Q7.V2.20260731',
    macid: process.env.VUE_APP_MACID
  }
}
